<script lang="ts">
  import { ethers } from 'ethers'
  import { concat, parseUnits } from 'ethers/lib/utils'
  import { signer } from 'svelte-ethers-store'
  import { op } from '../contracts/utils/utils'
  import { afterTimestampConfig, Opcode, saleDeploy } from '../contracts/sale'
  import { setContext } from 'svelte'
  import { VERIFY_TIER_CONTRACT } from '../constants/constants'

  const deploy = async (
    recipient: string,
    reserve: string,
    cooldownDuration: string,
    minimumRaise: string,
    price: string,
    name: string,
    symbol: string,
    initialSupply: string,
    walletCap: string,
    startTime: number,
    endTime: number,
    reserveErc20: object,
    forwardAddress: string
  ) => {

    const staticPrice = parseUnits(
      price.toString(),
      reserveErc20['erc20decimals'],
    )
    const cap = parseUnits(walletCap.toString())

    const constants = [staticPrice, cap, ethers.constants.MaxUint256]

    const sources = [
      concat([
        op(Opcode.CURRENT_BUY_UNITS),
        op(Opcode.TOKEN_ADDRESS),
        op(Opcode.SENDER),
        op(Opcode.ERC20_BALANCE_OF),
        op(Opcode.ADD, 2),
        op(Opcode.VAL, 1),
        op(Opcode.GREATER_THAN),
        op(Opcode.VAL, 2),
        op(Opcode.VAL, 0),
        op(Opcode.EAGER_IF),
      ]),
    ];

    return saleDeploy(
      $signer,
      {
        canStartStateConfig: afterTimestampConfig(Math.floor(startTime / 1000)),
        canEndStateConfig: afterTimestampConfig(Math.floor(endTime / 1000)),
        calculatePriceStateConfig: {
          sources,
          constants,
          stackLength: 10,
          argumentsLength: 0,
        },
        recipient: recipient,
        reserve: reserve,
        cooldownDuration: parseInt(cooldownDuration.toString()),
        minimumRaise: parseUnits(
          minimumRaise.toString(),
          reserveErc20['erc20decimals'],
        ),
        dustSize: 0,
      },
      {
        erc20Config: {
          name: name,
          symbol: symbol,
          distributor: ethers.constants.AddressZero,
          initialSupply: parseUnits(initialSupply.toString()),
        },
        tier: VERIFY_TIER_CONTRACT,
        minimumTier: 0,
        distributionEndForwardingAddress: forwardAddress,
      },
    )
  }

  setContext('saleDeploy', deploy)
</script>

<slot />
